<div class="card" style="max-width: 400px">
  <div class="card-header d-flex align-items-center justify-content-between">
    <h4>Life Insurance Premium</h4>
    <!--This button has padding adjusted because accordian adds padding to buttons-->
    <button
      type="button"
      class="btn-close custom-btn-close p-0"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="card-body">
    <div>
      <label for="amount" class="form-label"
        >Declared Amount <span class="text-danger">*</span></label
      >
      <input
        appTrimInput
        type="text"
        class="form-control"
        placeholder="Declared Amount"
        formControlName="amount"
      />
      <div *ngIf="form.get('amount')?.errors?.['required']">
        <span class="text-danger">
          {{ getErrorMessage('amount') }}
        </span>
      </div>
    </div>
    <div class="pt-2">
      <label for="amount" class="form-label">Attach Proof <span class="text-danger">*</span></label>
      <input
        appTrimInput
        type="file"
        class="form-control"
        formControlName="amount"
        multiple
        disabled
      />
      <div *ngIf="form.get('amount')?.errors?.['required']">
        <span class="text-danger">
          {{ getErrorMessage('amount') }}
        </span>
      </div>
    </div>
    <div class="pt-3 text-end">
      <button type="submit" class="btn btn-primary">Submit</button>
    </div>
  </div>
</div>
